import React from 'react';
import translations from '../../lang';

const ConfirmModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language];

  return (
    <div className="modal">
      <div className="modal-content">
        <p>{message}</p>
        <button onClick={onConfirm}>{t.yes}</button>
        <button onClick={onClose}>{t.no}</button>
      </div>
    </div>
  );
};

export default ConfirmModal;
